import useTranslation from 'next-translate/useTranslation'
import { useSession } from 'next-auth/react'
import styles from './AtsIntegrationTable.module.scss'
import CheckboxItem from '../../molecules/Pricing/CheckboxItem'

const EmployerBrandingTable = () => {
  const { data: session } = useSession()
  const { t } = useTranslation('pricing')

  return (
    <div className={styles['ats-integration-table']}>
      <div className={`${styles['ats-integration-table__description']}`}>
        <h2>{t('ebTitle')}</h2>
        <div className='mt-8'>
          <CheckboxItem
            itemKey='pricing:ebPoint1'
            components={[
              <b className='font-bold' />,
              <br />,
              <b className='font-bold' />,
            ]}
            color='text-action'
          />
          <CheckboxItem
            itemKey='pricing:ebPoint2'
            components={[<b className='font-bold' />, <br />]}
            color='text-action'
          />
          <CheckboxItem
            itemKey='pricing:ebPoint3'
            components={[
              <b className='font-bold' />,
              <br />,
              <b className='font-bold' />,
            ]}
            color='text-action'
          />
        </div>
      </div>

      <div className={`${styles['ats-integration-table__plus']}`}>
        <div className='my-6'>
          <div
            className={`${styles['ats-integration-table__price']} text-center`}
          >
            {t('ebCtaTitle')}
          </div>
        </div>
        <div className='my-6'>
          <div className='text-center'>{t('ebCtaSub')}</div>
        </div>

        <button
          type='button'
          onClick={() => {
            const message = document.querySelector(
              '#contact-form input[name=message]'
            )
            if (message) (message as HTMLInputElement).value = t('ebMessage')
            document.getElementById('contact-form')?.scrollIntoView({
              behavior: 'smooth',
            })
          }}
          className=' bg-action text-white w-full px-6 py-4 text-lg rounded-full inline-block text-center text-xl font-thin duration-300 hover:bg-raspberry-500'
        >
          {t('needMoreContact')}
        </button>
      </div>
    </div>
  )
}

export default EmployerBrandingTable
